/**
 * format.js
 * Shared formatting helpers used across views.
 */

// one Intl formatter per shape (toLocaleString builds a new one on every call)
const TWO_DP = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const UP_TO_2 = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

/** 1,234.50: grouped, always 2 decimals, the sign (if any) kept. */
export const amount2 = (n) => TWO_DP.format(n);
/** -$1,234.50 / -SAR 1,234.50: the sign before the symbol, the number as given (no rounding first). */
export const signedMoney = (n, sym = '$') => `${n < 0 ? '-' : ''}${sym}${TWO_DP.format(Math.abs(n))}`;
/** 1,234.5: grouped, at most 2 decimals. */
export const upTo2 = (n) => UP_TO_2.format(n);
/** Money and hours as the cost screens show them: cents first, so -$0.004 is $0.00; blank is 0. */
export const fmtCost = (v) => signedMoney(Math.round((Number(v) || 0) * 100) / 100);
export const fmtHours = (v) => upTo2(Number(v) || 0);

/** Format a number as a dollar string, or return "-" if zero/falsy/NaN/Infinity */
export const fmt = (n) => {
  const v = Number(n);
  if (n == null || !isFinite(v) || isNaN(v) || v <= 0) return '-';
  // money always shows cents (Sharif: "all the values 2 decimal places always")
  return `$${amount2(v)}`;
};

/**
 * Money for table cells / CSV: always 2 decimals, empty string when blank
 * (unlike fmt(), zero and negatives still render - a credit is information).
 */
export const fmtMoney = (v) => (v != null && v !== '' ? `$${amount2(parseFloat(v))}` : '');

/**
 * Dates for CRM panels: mm/dd/yyyy (Paul: "inconsistent with mm/dd/yyyy used
 * elsewhere"). Accepts 'YYYY-MM-DD', an ISO timestamp, or a Date; '' when blank.
 * A DATE column arrives as an ISO midnight timestamp - the leading YYYY-MM-DD
 * is the stored day, so it is read off the string rather than re-parsed.
 */
export const fmtDate = (d) => {
  if (!d) return '';
  const s = String(d);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[2]}/${m[3]}/${m[1]}`;
  const dt = new Date(s);
  if (isNaN(dt)) return s;
  return `${String(dt.getMonth() + 1).padStart(2, '0')}/${String(dt.getDate()).padStart(2, '0')}/${dt.getFullYear()}`;
};
